export function formatTime(timestamp: number | null): {
	time: string;
	unit: string;
} {
	if (!timestamp) {
		return { time: '', unit: '' };
	}

	const now = new Date().getTime();
	const difference = timestamp - now;

	const seconds = Math.floor(difference / 1000);
	const minutes = Math.floor(seconds / 60);
	const hours = Math.floor(minutes / 60);
	const days = Math.floor(hours / 24);

	if (days >= 2) {
		return { time: days.toString(), unit: 'д.' };
	} else if (hours >= 1) {
		const hoursPart = (hours % 24).toString().padStart(2, '0');
		const minutesPart = (minutes % 60).toString().padStart(2, '0');
		return { time: `${hoursPart}:${minutesPart}`, unit: '' };
	} else {
		const minutesPart = minutes.toString().padStart(2, '0');
		const secondsPart = (seconds % 60).toString().padStart(2, '0');
		return { time: `${minutesPart}:${secondsPart}`, unit: '' };
	}
}

export function preloadImage(imgSrc: string, callback: () => void) {
	const objImagePreloader = new Image();

	objImagePreloader.src = imgSrc;
	if (objImagePreloader.complete) {
		callback();
		objImagePreloader.onload = function () {};
	} else {
		objImagePreloader.onload = function () {
			callback();
			objImagePreloader.onload = function () {};
		};
	}
}

export function formatPromocodeTime(
	playTimePassedSec: number,
	playTimeRequiredSec: number,
): {
	current: string;
	target: string;
	unit: string;
} {
	const required = Math.max(0, Math.floor(playTimeRequiredSec));
	const passed = Math.max(0, Math.floor(playTimePassedSec));

	if (required === 0) {
		return { current: '0', target: '0', unit: 'мин.' };
	}

	let unit: 'д.' | 'ч.' | 'мин.';
	let divider: number;

	if (required >= 2 * 86400) {
		unit = 'д.';
		divider = 86400;
	} else if (required >= 2 * 3600) {
		unit = 'ч.';
		divider = 3600;
	} else {
		unit = 'мин.';
		divider = 60;
	}

	const currentVal = Math.floor(passed / divider);
	const targetVal = Math.floor(required / divider);

	return {
		current: currentVal.toString(),
		target: targetVal.toString(),
		unit,
	};
}
